var _defs, _ellipse, _path, _polygon, _polygon2, _rect, _path2, _polygon3, _path3, _rect2, _rect3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _rect4, _rect5, _rect6, _rect7, _rect8, _g18, _g19, _g20, _g21, _polygon4, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _polygon5, _path32, _g22, _path33, _path34, _polygon6, _path35, _path36, _path37, _path38, _path39;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTraning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b8be6891-8c6c-471d-9cef-5646484caaf2",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1044.13,
    height: 832.56,
    viewBox: "0 0 1044.13 832.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d33503b9-d00b-4906-a77e-d13cea74428d",
    x1: -19.7,
    y1: 839.45,
    x2: -19.7,
    y2: 151.58,
    gradientTransform: "translate(866.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "business plan") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.68,
    cy: 802.68,
    rx: 430.73,
    ry: 29.88,
    fill: "#35979C",
    opacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112,128.84c-26.84,31.42-33.63,71.25-34,109.44-.26,26.93,3.42,56.14,25.9,76,29.59,26.13,86.4,31.28,101.06,64.67,13,29.67-17.25,59.52-46.31,80.46s-62.43,46.58-57,77.76c3.44,19.91,22.31,35.54,41.13,48.66,35.78,25,76,46.87,121.34,57.51,82.26,19.28,171.11-.68,248.19-30.9,47.45-18.6,102.54-41.43,149.66-22.3,12.44,5.05,23,12.68,34.47,19,33.35,18.27,74.08,25,113.72,30.71,58.1,8.4,119.16,15.41,175.14.26s104.36-59.46,95.79-106.72c-8.08-44.52-59.52-73.54-100.51-103.95-14.46-10.73-29.18-24.95-25.58-40.56,2.86-12.38,16.32-21,28.32-29,63.16-42.34,109.58-100.79,130.92-164.88,10.08-30.24,13.72-65.08-8.77-90.58-18.14-20.57-49.23-30.45-78.8-38.58C971.8,50.75,915.56,38,857.85,34.56S740.52,37.68,689.29,59.45c-24.57,10.45-46.84,24.21-71.65,34.27-70.44,28.56-153.44,24.72-232,20.21-28.07-1.61-57.41-4.47-81.78-16.73-21-10.58-33-18.16-59-19.34C193.9,75.55,141.18,94.62,112,128.84Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#35979C",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "414.46 310.36 413.36 312.63 406.23 327.28 331.44 480.85 204.53 791.81 186.39 791.95 313.37 480.85 399.9 303.15 406.23 306.28 413.36 309.81 414.46 310.36",
    fill: "#535461"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "637.12 791.95 622.19 791.81 495.27 480.85 422.45 331.31 413.36 312.63 412.25 310.36 413.36 309.81 422.45 305.31 426.82 303.15 512.05 480.85 637.12 791.95",
    fill: "#535461"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 406.23,
    y: 261.38,
    width: 16.23,
    height: 530.57,
    fill: "#535461"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M490.43,207.69a20.67,20.67,0,0,0-20.65,20.65v7.38a20.66,20.66,0,1,0,41.31,0v-7.38A20.68,20.68,0,0,0,490.43,207.69Zm15.49,28a15.49,15.49,0,0,1-31,0v-7.38a15.49,15.49,0,1,1,31,0Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#535461"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "512.05 480.85 495.27 480.85 422.45 331.31 422.45 480.85 406.23 480.85 406.23 327.28 331.44 480.85 313.37 480.85 399.9 303.15 406.23 306.28 406.23 261.38 422.45 261.38 422.45 305.31 426.82 303.15 512.05 480.85",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M511.09,229.08v6.64a20.66,20.66,0,1,1-41.31,0v-6.64h5.16v6.64a15.49,15.49,0,0,0,31,0v-6.64Z",
    transform: "translate(-77.94 -33.72)",
    opacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100.45,
    y: 196.84,
    width: 624.09,
    height: 281.8,
    fill: "#535461"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 111.52,
    y: 205.69,
    width: 600.48,
    height: 256.72,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.82,
    y: 233.6,
    width: 28.39,
    height: 12.93,
    fill: "#35979C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.82,
    y: 258.61,
    width: 28.39,
    height: 12.93,
    fill: "#35979C"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.82,
    y: 283.61,
    width: 28.39,
    height: 12.93,
    fill: "#35979C"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.82,
    y: 308.61,
    width: 28.39,
    height: 12.93,
    fill: "#35979C"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.82,
    y: 333.62,
    width: 28.39,
    height: 12.93,
    fill: "#35979C"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.82,
    y: 358.62,
    width: 28.39,
    height: 12.93,
    fill: "#35979C"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.82,
    y: 383.62,
    width: 28.39,
    height: 12.93,
    fill: "#35979C"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.82,
    y: 408.62,
    width: 28.39,
    height: 12.93,
    fill: "#35979C"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.27,
    y: 421.56,
    width: 28.39,
    height: 12.93,
    fill: "#35979C"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.28,
    y: 421.56,
    width: 28.39,
    height: 12.93,
    fill: "#35979C"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.28,
    y: 421.56,
    width: 28.39,
    height: 12.93,
    fill: "#35979C"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.29,
    y: 421.56,
    width: 28.39,
    height: 12.93,
    fill: "#35979C"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424.29,
    y: 421.56,
    width: 28.39,
    height: 12.93,
    fill: "#35979C"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 474.3,
    y: 421.56,
    width: 28.39,
    height: 12.93,
    fill: "#35979C"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.3,
    y: 421.56,
    width: 28.39,
    height: 12.93,
    fill: "#35979C"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 574.31,
    y: 421.56,
    width: 28.39,
    height: 12.93,
    fill: "#35979C"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 624.31,
    y: 421.56,
    width: 28.39,
    height: 12.93,
    fill: "#35979C"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 224.27,
    y: 327.58,
    width: 28.39,
    height: 81.04,
    fill: "#35979C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 274.28,
    y: 290.08,
    width: 28.39,
    height: 118.55,
    fill: "#35979C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 324.28,
    y: 258.61,
    width: 28.39,
    height: 150.02,
    fill: "#35979C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 374.29,
    y: 274.92,
    width: 28.39,
    height: 133.7,
    fill: "#35979C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 424.29,
    y: 246.54,
    width: 28.39,
    height: 162.09,
    fill: "#35979C"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 474.3,
    y: 308.61,
    width: 28.39,
    height: 100.01,
    fill: "#35979C"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.3,
    y: 308.61,
    width: 28.39,
    height: 100.01,
    fill: "#35979C"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 574.31,
    y: 308.61,
    width: 28.39,
    height: 100.01,
    fill: "#35979C"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 624.31,
    y: 308.61,
    width: 28.39,
    height: 100.01,
    fill: "#35979C"
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "621.05 308.39 377.95 323.35 377.95 328.09 626.23 318.24 621.05 308.39",
    fill: "#535461"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M986.81,440.87s12.72-20.92,9.34-53.74-15.61-85.94-15.61-85.94,5.31-29.76-23.49-33.94c0,0-17.9-3.33-30.7-11.38-4.76-3-8.81-6.63-11-11,0,0-.17.49-.5,1.39a15.87,15.87,0,0,1-.78-1.39s-.07.18-.18.5L909,237.75s-.67.71-1.8,1.88a50.88,50.88,0,0,1-5-9,26,26,0,0,0,3.57-1.14,7,7,0,0,0,2.91-1.86,7.38,7.38,0,0,0,1.32-3.29,40,40,0,0,0,.66-11.56c-.27-3-.88-6-.67-9.05.22-3.25,1.37-6.39,1.53-9.65.28-5.74-2.57-11.2-6.09-15.75-2.1-2.71-4.46-5.23-6.28-8.13-1.58-2.52-2.73-5.3-4.43-7.75-4-5.7-10.67-9.06-17.51-10.25s-13.88-.45-20.73.68c-6,1-12,2.45-18,2.8-5.24.3-9.51-1.47-14.31,2a13.84,13.84,0,0,0-5.58,10,5.29,5.29,0,0,0,.15,2,14.37,14.37,0,0,0,1,1.95c2.13,4.2-1.11,9.19-.69,13.88a9.27,9.27,0,0,0,8.2,8.08c-.19.4-.4.79-.58,1.2a41.48,41.48,0,0,0,33.87,58.07l1.86,1.43c4.2,3.25,8.92,7.14,13.47,11.37l-.09.07-.74-.42a39.84,39.84,0,0,1-4.36,3c-4.21,2.58-11,5.93-18.64,6.31,0,0-13.68,7.25-18.39,31.16-6.76,6.06-21.23,17-40.35,19.85-26.87,4-60,5.31-60,5.31s-.27.48-.65,1.36l-3.06-.56s0,.37-.13,1l-1.2-.54c-9.49-4.15-28.45-10.2-30.85,6.47-3.22,22.36,18.1,19.79,18.1,19.79a99.42,99.42,0,0,1,12.93-3.93l1.19-.23a6.62,6.62,0,0,0,.84,1.64h2.9a34.23,34.23,0,0,0,3.63,5.9l67.58-1.48s11.55-2.52,22.21-.92c-4.65,34.76-10.14,72.88-10.14,72.88S805.15,492.69,813.2,499a122.5,122.5,0,0,1,14.26-3.82,64.9,64.9,0,0,0,1.18,11.11L833.79,540s2,34.44,8.69,55l5.9,28.1,4.94,21.24,2.78,36.05a342.38,342.38,0,0,1,8.26,46.44c2.61,24.22,16.78,63.36,18.67,68.51-4.84,6.85-14.78,18.47-27.25,19.67-17.8,1.72-18.23,12.45-5.79,16.31s38.62,0,38.62,0l36.92-9.13c-1.11,6.81-1.69,12.19-.88,12.77,2.36,1.72,38.19,11,39.48-3.86q.15-1.84.27-3.57a75.59,75.59,0,0,0-3.75-28.1c-.29-.89-.55-1.79-.78-2.69a16.59,16.59,0,0,0,1.46-1.89s2.58-40.12,4.51-54.5c.15-1.15.25-2.55.3-4.13.89-17.24-5.4-62.59-5.4-62.59s-7.77-29.5-7.48-43.06a12.94,12.94,0,0,1,.57-3.32s0-.27-.1-.72c0-.19.09-.39.15-.57,0,0-3.94-27-3.39-43.06a33.31,33.31,0,0,1,1-7.1,46.65,46.65,0,0,0,.95-9.27c.5-11-.08-30-.88-47.82.09-.3.18-.6.25-.95a9.3,9.3,0,0,0-.49-4.2c-.06-1.15-.11-2.29-.17-3.42.33-1.13.6-2.33.84-3.57l.52,0,0,.07s33.62-1.61,41.35-10.62c0,0-7.81-24.27-12.14-44ZM841.93,365.38l-.53-.19c.85-3,1.86-6.49,3-10.15C843.43,359,842.59,362.6,841.93,365.38Zm34.12-99.49.15.14-.16-.09Zm42,520.52c-1.81-6.23-9-31.63-8.77-43.74a12.34,12.34,0,0,1,.55-3.1,23.16,23.16,0,0,0,1-6.77c.72-12.64-4.12-35.29-4.12-35.29s-10.83-30.55-10-54.81c0-.61.07-1.22.11-1.83.18-2.3.32-4.79.42-7.42v-.05c.41-9.37.32-20.65.05-31.17l-.06-.39c-.37-13.93-1.06-26.47-1.35-31.43,1,7.17,7.4,51.8,10.16,59.1,0,0,1.51,20.59,8.37,38l7.52,45.26s1.93,53.86,5.14,69.09c1.44,6.78,2.66,11.35,3.57,14.33-1.3,6.07-3.4,16.24-4.81,24.66C925,815.36,922.08,794.44,918.06,786.41Z",
    transform: "translate(-77.94 -33.72)",
    fill: "url(#d33503b9-d00b-4906-a77e-d13cea74428d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M885.9,787.8s-12.55,22.75-30.2,24.45-18.07,12.33-5.74,16.16,38.28,0,38.28,0l37-9.14s-4.47-36.58-10.42-38.49S885.9,787.8,885.9,787.8Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#4c4c78"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M931,788.22s-9.36,42.1-7,43.81,37.85,10.84,39.13-3.83q.15-1.85.27-3.54a75.06,75.06,0,0,0-3.72-27.85c-1-3-1.7-6.21-1.44-8.59C958.83,782.27,931,788.22,931,788.22Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#4c4c78"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M919.39,255.21s-28.71,70.52-23.6,47.87c3.38-15-18.47-34.93-33.58-46.64-7.69-6-13.63-9.81-13.63-9.81s53.9-62.84,50.08-35.73a40.83,40.83,0,0,0,2.94,21.88C907.55,246.92,919.39,255.21,919.39,255.21Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#ffb9b9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M736,355.39c-1.52-.39-4-.14-6.57.41a98.72,98.72,0,0,0-12.81,3.89s-21.13,2.55-17.94-19.61c2.37-16.52,21.16-10.52,30.57-6.42,3.2,1.41,5.32,2.59,5.32,2.59Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#ffb9b9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M736,355.39c-1.52-.39-4-.14-6.57.41-2.3-5.8-.55-19.55-.18-22.14,3.2,1.41,5.32,2.59,5.32,2.59Z",
    transform: "translate(-77.94 -33.72)",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M736.09,334.23l-5.53-1s-2.83,19,.87,24h6.36Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#cbcdda"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M847,368.9s-16.9-10.11-18.92,2.65-4.68,34.56-4.68,34.56l-4.68,27.75-6.06,55.6.85,9.46s18-6.06,22.22-3.93,7.66-23.39,7.66-23.39l7-26.37,1.06-55.92Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#4c4c78"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M847,368.9s-16.9-10.11-18.92,2.65-4.68,34.56-4.68,34.56l-4.68,27.75-6.06,55.6.85,9.46s18-6.06,22.22-3.93,7.66-23.39,7.66-23.39l7-26.37,1.06-55.92Z",
    transform: "translate(-77.94 -33.72)",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M837.89,303.4s-17.54,19.78-44.17,23.76-59.49,5.27-59.49,5.27-8.29,14.83,3.67,30.62l67-1.48s14.83-3.22,26.32,0Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#4c4c78"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M837.89,303.4s-17.54,19.78-44.17,23.76-59.49,5.27-59.49,5.27-8.29,14.83,3.67,30.62l67-1.48s14.83-3.22,26.32,0Z",
    transform: "translate(-77.94 -33.72)",
    opacity: 0.05
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M692.29,384.58",
    transform: "translate(-77.94 -33.72)",
    fill: "none",
    stroke: "blue",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M898.76,232.17c-6.54,14-17.91,24.32-34.4,24.32-.73,0-1.44,0-2.15-.05-7.69-6-13.63-9.81-13.63-9.81s53.9-62.84,50.08-35.73C897.48,219.2,896.13,225.94,898.76,232.17Z",
    transform: "translate(-77.94 -33.72)",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M905.44,214.12A41.09,41.09,0,1,1,864.36,173,41,41,0,0,1,905.44,214.12Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#ffb9b9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M930.55,465.22s-91.64,8.09-95-3.61,9.35-43.38,9.35-43.38L840.76,374l-.15-1.69s11.48-47.85,11.06-51.67c-.4-3.44,18.48-43.59,22.36-51.8.46-.95.7-1.47.7-1.47l.73.42.32.19,4.49,2.62L898,266.4l21.37-11.19,2,122.41Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#cbcdda"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M882.92,268.85s-6.27-1.7-8.72,4.57a65,65,0,0,1-3.4,7.87l-2.44,14.56-4.47,23-3.3,101.75,1.49,18.07,8.19-14.56L871.76,329V317.17a85.64,85.64,0,0,1,6.82-29.7l1.14-2.67,7.12-9.15Z",
    transform: "translate(-77.94 -33.72)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M881.65,267.57s-6.28-1.7-8.72,4.57a64.48,64.48,0,0,1-3.41,7.87l-2.44,14.57-4.47,23-3.29,101.75,1.49,18.08L869,422.8l1.49-95.05V315.89a86.09,86.09,0,0,1,6.82-29.7l1.15-2.67,7.12-9.14Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#4c4c78"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M908.44,241.31s-21.69,23-29.35,25.73c0,0,3.83,17.44,7.66,20.84,0,0,22.76-23.21,26.79-25.09l3.38-8.27Z",
    transform: "translate(-77.94 -33.72)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M908.44,240s-21.69,23-29.35,25.73c0,0,3.83,17.44,7.66,20.84,0,0,22.76-23.21,26.79-25.09l3.38-8.26Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#cbcdda"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M876,267.37l-.22.6-6.95,18.63L856.4,321.75s-.11.36-.33,1c-2.06,6.4-13.13,41.13-15.31,51.22l-.15-1.69s11.48-47.85,11.06-51.67c-.4-3.44,18.48-43.59,22.36-51.8.62-.42,1.1-.78,1.43-1.05Z",
    transform: "translate(-77.94 -33.72)",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M874.73,267.36l-7.18,19.24-12.43,35.15s-.11.36-.33,1c-2.18,6.82-14.61,45.75-15.61,52.87-1.13,7.82-16.76,50.09-16.76,50.09l-8.93,73.19c-8-6.21,3.36-66,3.36-66s12.76-88.67,15.78-118.17,19.31-38.12,19.31-38.12c7.52-.38,14.3-3.7,18.47-6.25A39,39,0,0,0,874.73,267.36Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#4c4c78"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M964.78,738.25c-1.91,14.25-4.46,54-4.46,54-8.93,13.39-28.71,6.16-28.71,6.16s-2.12-4-5.31-19.14-5.1-68.47-5.1-68.47L913.75,666c-6.8-17.23-8.29-37.64-8.29-37.64-3-7.87-10.21-59.54-10.21-59.54s3,46.35,1.07,70.81S906.09,697,906.09,697s6.6,30.84,3.19,40.41,8.51,49.11,8.51,49.11c-1,11.49-34.86,6.81-34.86,6.81S867,750.58,864.21,724.85a340,340,0,0,0-8.19-46l-2.76-35.73L848.36,622l-5.84-27.85c-6.6-20.41-8.61-54.54-8.61-54.54l-5.11-33.49c-3.34-16.56,1-36,3.88-46.17,1.25-4.41,2.25-7.1,2.25-7.1,2.93,2.08,19.71,4.52,28.39,6.5a49.76,49.76,0,0,0,14.5,1.16,323.1,323.1,0,0,0,64.79-11.88c1.43-.43,2.19-.68,2.19-.68l.45,3.83,1.06,9.12,1.89,16.19s5.74,86.33,2.34,98,2.34,51,2.34,51c-3.19,9.33,6.8,47.25,6.8,47.25S966.7,724,964.78,738.25Z",
    transform: "translate(-77.94 -33.72)",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M964.78,737c-1.91,14.25-4.46,54-4.46,54-8.93,13.4-28.71,6.16-28.71,6.16s-2.12-4-5.31-19.13-5.1-68.48-5.1-68.48l-7.45-44.86C907,647.46,905.46,627,905.46,627c-3-7.87-10.21-59.54-10.21-59.54s3,46.35,1.07,70.81,9.77,57.41,9.77,57.41,6.6,30.84,3.19,40.41,8.51,49.12,8.51,49.12c-1,11.48-34.86,6.8-34.86,6.8S867,749.31,864.21,723.57a340,340,0,0,0-8.19-46l-2.76-35.72-4.9-21.05-5.84-27.85c-6.6-20.42-8.61-54.55-8.61-54.55l-5.11-33.49c-3.34-16.56,1-36,3.88-46.17,1.25-4.4,2.25-7.09,2.25-7.09,2.93,2.08,19.71,4.51,28.39,6.49a49.42,49.42,0,0,0,14.5,1.16,323.1,323.1,0,0,0,64.79-11.88l2.19-.67.45,3.82,1.06,9.13,1.89,16.19s5.74,86.32,2.34,98,2.34,51,2.34,51c-3.19,9.32,6.8,47.24,6.8,47.24S966.7,722.73,964.78,737Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#474463"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M905.44,214.12A41,41,0,0,1,900,234.6c-6.4,1.13-13.21-.12-18-4.35-3.28-2.89-5.4-6.84-8.22-10.19a61.71,61.71,0,0,0-5.87-5.79,18.63,18.63,0,0,0-4.63-3.37,6.29,6.29,0,0,0-5.55-.06c-2.26,1.26-3,4.07-4.31,6.31a8.43,8.43,0,0,1-4.71,4.11,5,5,0,0,1-5.63-1.91c-1.39-2.39-.37-6.12-2.7-7.58a14.87,14.87,0,0,0-1.9-.78c-3-1.36-3.35-5.39-3.61-8.69-.13-1.62-.48-3.45-1.84-4.32s-3.15-.43-4.77-.4a6.19,6.19,0,0,1-1.43-.11,41.09,41.09,0,0,1,78.65,16.65Z",
    transform: "translate(-77.94 -33.72)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M824.31,160.68a13.72,13.72,0,0,0-5.53,9.94,5.12,5.12,0,0,0,.15,1.95,13.18,13.18,0,0,0,1,1.94c2.1,4.17-1.11,9.11-.7,13.76a9.15,9.15,0,0,0,9,8c1.62,0,3.4-.48,4.77.4s1.71,2.7,1.84,4.32c.26,3.3.59,7.33,3.6,8.69a16.81,16.81,0,0,1,1.9.78c2.34,1.46,1.32,5.2,2.71,7.58a5,5,0,0,0,5.63,1.91,8.4,8.4,0,0,0,4.7-4.1c1.29-2.25,2.06-5,4.32-6.31a6.26,6.26,0,0,1,5.55.05,18.67,18.67,0,0,1,4.63,3.38,60.54,60.54,0,0,1,5.87,5.79c2.82,3.34,4.94,7.29,8.22,10.18,6.18,5.43,15.64,6,23.26,2.87a7.06,7.06,0,0,0,2.89-1.84,7.34,7.34,0,0,0,1.31-3.27,39.65,39.65,0,0,0,.66-11.45c-.27-3-.88-6-.67-9,.21-3.22,1.36-6.33,1.52-9.55.28-5.7-2.55-11.11-6-15.62-2.08-2.69-4.42-5.18-6.22-8.06-1.57-2.5-2.71-5.25-4.39-7.67-3.94-5.65-10.58-9-17.36-10.17s-13.75-.45-20.54.68c-5.92,1-11.88,2.42-17.88,2.77C833.3,159,829.07,157.23,824.31,160.68Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#472727"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M874.73,267.36l-7.18,19.24-12.43,35.15s-.11.36-.33,1l0,.05,15.64-52.46A39,39,0,0,0,874.73,267.36Z",
    transform: "translate(-77.94 -33.72)",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M952.35,487.55s.74,23.28-5.53,29.13l-16.69-31.47,14-6.81Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#ffb9b9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M991.31,496.05c-7.66,8.93-41,10.53-41,10.53l-33-52s-7.81-5.42-22.48-29.83-14.19-43.21-13.37-57.25,10-54.39,10-54.39c1.43-9.08,22-66,22-66,2.16,4.31,6.18,7.91,10.88,10.88,12.7,8,30.43,11.28,30.43,11.28,28.56,4.15,23.29,33.65,23.29,33.65s.32,114.67-1.44,128.39S991.31,496.05,991.31,496.05Z",
    transform: "translate(-77.94 -33.72)",
    opacity: 0.1
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "874.84 458.29 873.88 466.8 862.29 462.55 853.79 449.68 860.17 444.68 874.84 458.29",
    fill: "#cbcdda"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M952.37,459.05l-6.06.62-58.43,5.84a94.65,94.65,0,0,1-28.1-1.38l-27.1-5.42c1.25-4.4,2.25-7.09,2.25-7.09,2.93,2.08,19.71,4.51,28.39,6.49a49.42,49.42,0,0,0,14.5,1.16,323.1,323.1,0,0,0,64.79-11.88l2.64,3.15Z",
    transform: "translate(-77.94 -33.72)",
    opacity: 0.1
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M835.54,451.94a5.3,5.3,0,0,1-.56-.32s0,.06-.06.15Z",
    transform: "translate(-77.94 -33.72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.73,672.12s-10-37.92-6.8-47.24c0,0-5.74-39.3-2.33-51s-2.35-98-2.35-98l-1.89-16.19-1.06-9.13-.44-3.82-2.2.67-1.36.4.17,1.48,1.06,9.12,1.89,16.19s5.74,86.33,2.35,98,2.33,51,2.33,51c-3.19,9.33,6.8,47.24,6.8,47.24s7,50.62,5.11,64.86-4.47,54-4.47,54c-6.52,9.79-18.83,8.57-25,7.2l.11.24s19.78,7.24,28.71-6.16c0,0,2.55-39.77,4.47-54S959.73,672.12,959.73,672.12Z",
    transform: "translate(-77.94 -33.72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.34,736.13c3.4-9.57-3.19-40.41-3.19-40.41s-11.69-33-9.78-57.41c.8-10.19.75-24.17.41-37-2.71-16.55-5.31-35-5.31-35s3,46.35,1.08,70.8,9.77,57.42,9.77,57.42,6.6,30.83,3.19,40.4S914,784,914,784c-.85,9.2-22.7,8-31.37,7.2l.33.88s33.81,4.68,34.87-6.8C917.85,785.25,905.94,745.7,909.34,736.13Z",
    transform: "translate(-77.94 -33.72)"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M992.58,496.05c-7.65,8.93-41,10.53-41,10.53l-33-52s-7.81-5.42-22.49-29.83-14.18-43.21-13.37-57.25,10-54.39,10-54.39c1.43-9.08,22-66,22-66,2.15,4.31,6.17,7.91,10.88,10.88,12.7,8,30.43,11.28,30.43,11.28,28.55,4.15,23.28,33.65,23.28,33.65s.32,114.67-1.44,128.39S992.58,496.05,992.58,496.05Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#4c4c78"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M920.83,275.33,913.65,278l4.78,3.35-35.7,86.12c.83-14,10-54.39,10-54.39,1.43-9.08,22-66,22-66,2.15,4.31,6.17,7.91,10.88,10.88Z",
    transform: "translate(-77.94 -33.72)",
    opacity: 0.1
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "851.5 395.03 888.02 385.62 892.81 400.45 855.49 409.55 851.5 395.03",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M950.33,281.39S933.74,297,940,331.79s16.27,72.56,16.27,72.56l-27,74.8s18.82,19.62,28.07,22l26.95-59.81s12.6-20.73,9.25-53.26-15.47-85.17-15.47-85.17S978.08,270.87,950.33,281.39Z",
    transform: "translate(-77.94 -33.72)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M951.6,281.39S935,297,941.24,331.79s16.26,72.56,16.26,72.56l-27,74.8s18.82,19.62,28.07,22l27-59.81s12.6-20.73,9.25-53.26-15.47-85.17-15.47-85.17S979.35,270.87,951.6,281.39Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#4c4c78"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M931.4,480.74s21.05,29.14,19.46,36.9-7.76,3.61-7.76,3.61l-8.29-11.37-7.45-21.27S928.09,479.43,931.4,480.74Z",
    transform: "translate(-77.94 -33.72)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M928.85,480.74s21,29.14,19.46,36.9-7.76,3.61-7.76,3.61l-8.3-11.37-7.44-21.27S925.54,479.43,928.85,480.74Z",
    transform: "translate(-77.94 -33.72)",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M930.13,480.74s21,29.14,19.45,36.9-7.76,3.61-7.76,3.61l-8.29-11.37-7.44-21.27S926.81,479.43,930.13,480.74Z",
    transform: "translate(-77.94 -33.72)",
    fill: "#474463"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraning);
export default __webpack_public_path__ + "static/media/traning.49b2c376c5d9b68f6f898c76f010b7cb.svg";
export { ForwardRef as ReactComponent };